module.exports = __webpack_public_path__ + "img/WP2023-see-you-there-1200-630.517bad9d.png";